import {useState, useEffect } from 'react';
import {useLocation } from 'react-router-dom';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import EditBack from '../../components/common/EditBack';
import Updating from '../../components/common/Updating';
import Error from '../../components/common/Error';
import CustomersEdit from '../../components/system/Customers/CustomersEdit';
import CustomersLinkList from '../../components/system/Customers/CustomersLinkList';
import CustomersUserList from '../../components/system/Customers/CustomersUserList';

export default function CustomersPageEdit( props ){
    //console.debug("RTS Break CustomersPageEdit");

    const location = useLocation();
    const idGuid = location.state.idGuid;
    const display = location.state.display;
    const mode = location.state.mode;
    const initTab = location.state.tab;

    const [isUpdating, setIsUpdating] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [hasError, setHasError] = useState(false);

    const [showConfirmModal, setShowConfirmModal] = useState(false);

    const [formDirty, setFormDirty] = useState(0);
    const [tabIndex, setTabIndex] = useState(0);
    const [newTabIndex, setNewTabIndex] = useState(0);


    useEffect(() => {
        props.setIsModalFx(true);
        setTabIndex(initTab!=null?initTab:0);
    }, [props, initTab]); 


    const handleChange = (e, curIndex) => {
        setNewTabIndex(curIndex);
        if(formDirty===1){
            setShowConfirmModal(true);
        }
        else{
            switchTabs(curIndex);
        }
    };


    function switchTabs(curIndex){
        window.scrollTo(0,0);
        setShowConfirmModal(false);
        setFormDirty(0);
        if(mode===1){
            setTabIndex(curIndex);
        }
    } 
    
    
    function updateCurData(complete){
        if(complete === 1){
            setIsUpdating(false);
            setShowSuccessModal(true);
        }
        else{
            setIsUpdating(true);
            setShowSuccessModal(false);
        }
    }


    if(hasError){
        return(
            <Error />
        );
    }


    if(isUpdating){
        return(
            <Updating />
        );
    };   


    return(
        <>
        <Dialog fullWidth={true} open={showConfirmModal}>
            <DialogTitle>Leave Tab?</DialogTitle>
            <DialogContent>
                <Typography>Changes will be lost.</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {switchTabs(newTabIndex);}}>Yes</Button>
                <Button variant="contained" onClick={e => {setShowConfirmModal(false);}}>No</Button>
            </DialogActions>
        </Dialog> 
        <Dialog fullWidth={true} open={showSuccessModal}>
            <DialogTitle>Data Updated</DialogTitle>
            <DialogContent>
                <Typography>Customer Current Data has been successfully updated.</Typography>
            </DialogContent>
            <DialogActions>
                <Button variant="contained" onClick={e => {setShowSuccessModal(false);}}>Ok</Button>
            </DialogActions>
        </Dialog>                 
        <Container component="main" maxWidth="md" sx={{mb:5}}>            <CssBaseline />
            <CssBaseline />
            <Box sx={{my:2, width:'100%', display:'flex', justifyContent:'start', alignContent:'center', whiteSpace:'nowrap'}}>
                <EditBack formDirty={formDirty} />
                {formDirty===0
                ?
                    <Typography variant="h5" >Edit Customer</Typography>
                :
                    <Typography variant="h5" sx={{fontStyle:'italic'}}>Edit Customer *</Typography>
                }
            </Box>

            <Box sx={{ borderBottom: 1, borderColor: 'divider', mb:1 }}>
                <Tabs value={tabIndex} onChange={handleChange}>
                    <Tab label="Overview" value={0} />
                    {mode===1?<Tab label="Links" value={1} />:''}
                    {mode===1?<Tab label="Users" value={2} />:''}
                </Tabs>
            </Box>

            {
            tabIndex === 2
            ?
                <>
                <Box>
                    <CustomersUserList idGuid={idGuid} display={display} mode={mode} formDirty={formDirty} setFormDirtyFx={setFormDirty} />
                </Box>
                </>
            :
                tabIndex === 1
                ?
                    <>
                    <Box>
                        <CustomersLinkList idGuid={idGuid} display={display} mode={mode} formDirty={formDirty} setFormDirtyFx={setFormDirty} />
                    </Box>
                    </>
                :
                    <>
                    <Box>
                        <CustomersEdit idGuid={idGuid} display={display} mode={mode} formDirty={formDirty} setFormDirtyFx={setFormDirty} updateCurDataFx={updateCurData} setHasErrorFx={setHasError} />
                    </Box>
                    </>
            }
            <Box sx={{my:2, width:'100%', display:'flex', justifyContent:'start', alignContent:'center'}}>
                <EditBack formDirty={formDirty} />
            </Box>
      </Container>
      </>
    );
}
